module.exports = __webpack_public_path__ + "img/Stone-Pagamentos-Cartao.b97ce96f.jpg";